import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Body } from 'syf-component-library/ui/typography';
import { Inset } from 'syf-component-library/ui/spacing';
import { formatDate } from 'syf-component-library/helpers/dateValidation';
import { AddAuthUserInputType } from '../../../../typings';
import getInputErrorMessage from '../../../../modal/content/helpers/get-input-error-message';
import { translate } from '../../../../strings/i18n';
import { ContentWrapper, DateOfBirthInputContainer } from './subcomponents';
import AuthorizedUsersPrivileges from './AuthorizedUsersPrivileges';
import { HeaderContainer, Label, MembershipNumberContainer, UserInfoContainer, UserNameContainer } from '../../EligibleMemberList/subcomponents';
import { useManageCardHolderModalContext } from '../../../../context/manage-card-holder-modal-context';
import DateOfBirthInput from '../../DateOfBirthInput';
import AddUserLegalContent from '../../AddUserLegalContent';
const UserFormSams = () => {
    const { isAuthorizedUserSubmitted, selectedSamsUser, updateDateOfBirth, updateSelectedSamsUser } = useManageCardHolderModalContext();
    const { touched, errorMessage, value: { 'cipher.dateOfBirth': dateOfBirth } } = selectedSamsUser;
    const birthDateError = ((isAuthorizedUserSubmitted || touched) && errorMessage) || '';
    const handleInputChange = (newDateValue) => {
        if (selectedSamsUser.errorMessage)
            updateSelectedSamsUser({
                ...selectedSamsUser,
                errorMessage: undefined
            });
        updateDateOfBirth((dateOfBirth || '').length <= newDateValue.length
            ? formatDate(newDateValue)
            : newDateValue);
    };
    const handleBlur = () => {
        const newErrorMessage = getInputErrorMessage(AddAuthUserInputType.authorizedUserBirthDate, dateOfBirth || '');
        updateSelectedSamsUser({
            ...selectedSamsUser,
            touched: true,
            errorMessage: newErrorMessage
        });
    };
    useEffect(() => {
        if (isAuthorizedUserSubmitted)
            handleBlur();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthorizedUserSubmitted]);
    return (_jsxs(_Fragment, { children: [_jsx(ContentWrapper, { children: _jsx(AuthorizedUsersPrivileges, {}) }), _jsxs(Inset, { vertical: "large", children: [_jsxs(HeaderContainer, { horizontal: "medium", borderTop: true, borderBottom: true, children: [_jsx(Body, { weight: "bold", children: translate('addAuthUserScreen.nameLabel') }), _jsx(Body, { weight: "bold", children: translate('addAuthUserScreen.membershipNumber') })] }), _jsxs(Inset, { top: "medium", bottom: "xxlarge", children: [_jsxs(UserInfoContainer, { children: [_jsx(UserNameContainer, { children: `${selectedSamsUser.value?.['cipher.firstName']} ${selectedSamsUser.value?.['cipher.lastName']}` }), _jsx(Inset, { top: "xsmall", hideOnBreakpointUp: "small", children: _jsxs(MembershipNumberContainer, { children: [_jsxs(Label, { children: [translate('addAuthUserScreen.membershipNumber'), ' '] }), selectedSamsUser.value?.partnerId] }) })] }), _jsx(DateOfBirthInputContainer, { top: "large", children: _jsx(DateOfBirthInput, { dateValue: selectedSamsUser.value?.['cipher.dateOfBirth'], handleOnChange: handleInputChange, handleOnBlur: handleBlur, error: birthDateError }) }), _jsx(AddUserLegalContent, {})] })] })] }));
};
export default UserFormSams;
